
<style type="text/css" >
.logo{
	margin-top: 20px;
	margin-bottom: 5px;
	height: 100px;
}	

/* text align left */
.text-left{
	text-align: left !important;
}
/* text align left */
.text-right{
	text-align: right !important;
}

/* btn style*/
.signup-btn-style{
	border: 2px solid #1DC895;
	box-sizing: border-box;
	border-radius: 8px;
	color: #1DC895;
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 18px;
}
.head--text{
	font-family: Nunito Sans;
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.015em;
	color: #8E8B8B;
	margin-right: 10px;
}
.header-padding{
	padding-left: 51px;
	padding-right: 25px;
}


</style>
<template>
	<v-app>
		<div class="header-padding">
			<v-row align="center" >
				<v-col cols="6" md="6" class="text-left">
					<img src="@/assets/logo/medx-logo.svg" class="logo" />
				</v-col>
				<v-col cols="6" md="6" class="text-right">
					<div class="pt-5">
						<div v-if="$route.name=='wholesaler-login'">
							<span class="head--text">Don't have  an account?</span>
							<v-btn outlined color="primary" class="signup-btn-style" @click="$router.push({name:'signup'})">
								Sign Up
							</v-btn>
						</div>
						<div v-if="$route.name=='signup'">
							<span class="head--text">Have an account?</span>
							<v-btn outlined color="primary" class="signup-btn-style" @click="$router.push({name:'wholesaler-login'})">
								Login
							</v-btn>
						</div>
					</div>
				</v-col>
			</v-row>
		</div>
		<v-row align="center" class="h-100" >
			<v-col cols="12" md="12" >
				<router-view/>
			</v-col>
		</v-row>
		<!-- snake bar  -->
		<snakebar/>

	</v-app>
</template>
<script type="text/javascript">


export default {
	components: {
		Snakebar: () => import('@/components/common-components/Snakebar.vue'),
	},
}
</script>